import LabelField from '@app/components/atoms/LabelField/LabelField'
import Section from '@app/components/atoms/Section/Section'
import { yupResolver } from '@hookform/resolvers/yup'
import { Inertia } from '@inertiajs/inertia'
import { InertiaLink } from '@inertiajs/inertia-react'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import PosCreateSchema from '../POSCreate/PosCreateSchema'

const ButtonCustom = styled(Button)({
  marginTop: 20,
  marginRight: 20,
})
const GridCustomizer = styled(Grid)({
  marginBottom: '5%',
})

export default function PosEdit({ pos }) {
  const { t } = useTranslation()

  const initialValues = {
    ...pos,
  }

  const onSubmit = (data) => {
    Inertia.put(route('merchant.pos.update', { po: data.id }), data, {
      onError: (errors) => {
        setError('longitude', { message: t(errors.longitude) })
        setError('latitude', { message: t(errors.latitude) })
      },
    })
  }

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    defaultValues: initialValues,
    resolver: yupResolver(PosCreateSchema),
  })

  return (
    <GridCustomizer container spacing={2}>
      <Grid item xs={12}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Section title={t('POS.BASIC_INFORMATION')}>
                <Grid item lg={7} md={12} sm={12} xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <LabelField required title={t('POS.NAME')}>
                        <TextField
                          fullWidth
                          name="name"
                          {...register('name')}
                          error={errors.name ? true : false}
                          helperText={errors.name?.message}
                          size="small"
                          type="text"
                          variant="outlined"
                        />
                      </LabelField>
                    </Grid>
                    <Grid item xs={12}>
                      <LabelField required title={t('POS.ADDRESS')}>
                        <TextField
                          fullWidth
                          name="address"
                          {...register('address')}
                          error={errors.address ? true : false}
                          helperText={errors.address?.message}
                          size="small"
                          type="text"
                          variant="outlined"
                        />
                      </LabelField>
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField required title={t('POS.CITY')}>
                        <TextField
                          fullWidth
                          name="city"
                          size="small"
                          type="text"
                          {...register('city')}
                          error={errors.city ? true : false}
                          helperText={errors.city?.message}
                          variant="outlined"
                        />
                      </LabelField>
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField required title={t('POS.LONGITUDE')}>
                        <TextField
                          fullWidth
                          {...register('longitude')}
                          error={errors.longitude ? true : false}
                          helperText={errors.longitude?.message}
                          name="longitude"
                          size="small"
                          type="tel"
                          variant="outlined"
                        />
                      </LabelField>
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField required title={t('POS.LATITUDE')}>
                        <TextField
                          fullWidth
                          name="latitude"
                          size="small"
                          type="text"
                          variant="outlined"
                          {...register('latitude')}
                          error={errors.latitude ? true : false}
                          helperText={errors.latitude?.message}
                        />
                      </LabelField>
                    </Grid>
                  </Grid>
                </Grid>
              </Section>
            </Grid>
            <Grid item xs={12}>
              <ButtonCustom type="submit" variant="contained">
                {t('BUTTON.SAVE')}
              </ButtonCustom>
              <ButtonCustom
                color="inherit"
                component={InertiaLink}
                href={route('merchant.pos.index')}
                variant="contained"
              >
                {t('BUTTON.CANCEL')}
              </ButtonCustom>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </GridCustomizer>
  )
}
